
import Vue from 'vue';
import api from '@/api/api';
import Grid from '@/components/Grid.vue';
import ModalCrud from '@/components/ModalCrud.vue';
import ModalOndeEstou from '@/components/OndeEstou/ModalOndeEstou.vue';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { columns } from '@/utils/columns';
import type { TModals, IGridItem } from '@/types/IOndeEstou';

const DEFAULT_ERR_MSG = 'Falha ao comunicar com o banco de dados!';

export default Vue.extend({
	name: 'OndeEstou',
	data() {
		return {
			grid: {
				isLoading: false,
				dataset: [],
				actions: [
					{
						label: 'Editar',
						action: 'edit',
						icon: 'mdi-pencil',
						color: 'primary',
						display: true,
						loading: false
					}
				],
				columns: columns.lancamentos.agenda
			},
			modalCrud: {
				visible: false,
				operation: 'post',
				id: null
			},
			modals: {
				filter: {
					data: {
						form: {
							colaboradores: [],
							atividades: [],
							departamentos: [],
							dataInicial: '',
							dataFinal: ''
						},
						inputs: {
							dsColaborador: [],
							dsAtividades: [],
							dsDepartamentos: [],
						}
					},
					visible: false,
					isLoading: false
				},
			}
		}
	},
	methods: {
		loadData: async function () {
			try {
				this.grid.isLoading = true;

				const response = await api.get('/compromises', {
					params: this.modals.filter.data.form
				});
				this.grid.dataset = response.data;
			} catch (error) {
				this.$toast.error(error.message ?? DEFAULT_ERR_MSG);
			} finally {
				this.grid.isLoading = false;
			}
		},
		handleModals: async function (modal: TModals, idCompromise: number = 0) {
			switch (modal) {
				case 'filter':
					this.openFilterModal();
					break;
				case 'form':
					this.handleOpenModalCrud(idCompromise === 0 ? 'post' : 'put', idCompromise === 0 ? null : idCompromise);
					break;
				default:
					this.$toast.error('Opção inválida!');
			};
		},
		handleModalsActions: async function (modal: TModals, action: 'confirm' | 'close') {
			switch (modal) {
				case 'filter':
					if (action === 'confirm') {
						this.modals.filter.isLoading = true;

						await this.loadData();
						this.closeFilterModal();
						this.resetFilterModal();
					}
					else if (action === 'close') {
						this.closeFilterModal();
						this.resetFilterModal();
					};
					break;
				default:
					this.$toast.error('Opção inválida!');
			}
		},
		handleGridActions: function (action: 'edit', item: IGridItem) {
			switch (action) {
				case 'edit':
					this.handleModals('form', item.ID);
					break;
				default:
					this.$toast.error('Opção de ação inválida!');
			};
		},
		openFilterModal: async function () {
			try {
				this.modals.filter.isLoading = true;
				this.modals.filter.visible = true;

				const response = await api.get('/compromises/data-filter');
				this.modals.filter.data.inputs.dsAtividades = response.data.atividades;
				this.modals.filter.data.inputs.dsColaborador = response.data.colaboradores;
				this.modals.filter.data.inputs.dsDepartamentos = response.data.departamentos;
			} catch (error) {
				this.$toast.error(error.message ?? DEFAULT_ERR_MSG);
			} finally {
				this.modals.filter.isLoading = false;
			}
		},
		closeFilterModal: function () {
			this.modals.filter.visible = false;
		},
		resetFilterModal: function () {
			this.modals.filter.isLoading = false;

			this.modals.filter.data.inputs = {
				dsColaborador: [],
				dsAtividades: [],
				dsDepartamentos: []
			};
		},
		handleOpenModalCrud(operation: string, id?: number) {
			this.modalCrud.visible = true;
			this.modalCrud.operation = operation;
			this.modalCrud.id = id;
		},
		async handleCloseModal() {
			this.modalCrud.visible = false;
		},
		async handleSavedModal() {
			await this.loadData();
			this.modalCrud.visible = false;
		}
	},
	async mounted() {
		store.commit(M_MENU, 'Agenda');
		await this.loadData();
	},
	components: {
		Grid,
		ModalCrud,
		ModalOndeEstou
	},
})

